"use client"

import type { ComponentProps, FunctionComponent } from "react"

import { clsx } from "clsx"
import { useSearchParams } from "next/navigation"
import { useEffect } from "react"

import { LayoutChild } from "@/modules/layouts/components/Layout/LayoutChild"

import { useLayoutContext } from "./LayoutContextProvider"

type InteractiveResultsProps = ComponentProps<typeof LayoutChild> & { loadingClassName: string }

export const InteractiveResults: FunctionComponent<InteractiveResultsProps> = ({
  children,
  className,
  loadingClassName,
  ...props
}) => {
  const { isSearchLoading, updateSearchLoadingStatus } = useLayoutContext()
  const nextSearchParams = useSearchParams()

  useEffect(() => {
    updateSearchLoadingStatus(false)
  }, [nextSearchParams, updateSearchLoadingStatus])

  return (
    <LayoutChild {...props} className={clsx(className, isSearchLoading && loadingClassName)}>
      {children}
    </LayoutChild>
  )
}
